
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Detail from "../../../components/groups/detail";
import PublicDetail from "../../../components/groups/public_detail";
import { useRouter } from "next/router";
import { getGroup, handleError } from "../../../src/queries";
import { useSession } from "next-auth/react";
import { useQuery, QueryClient, dehydrate } from "@tanstack/react-query";
import { authOptions } from "../../../pages/api/auth/[...nextauth]";
import { unstable_getServerSession } from "next-auth/next";
const Show = () => {
    const { data: session } = useSession();
    const router = useRouter();
    const token = router.query.token;
    const { data: group, refetch } = useQuery(["groups", token], () => getGroup(token), {
        onError: (error) => handleError(error, router)
    });
    return (<>
      {session?.user
            ? group && <Detail refetch={refetch} group={group} backLink={router.query.backLink}/>
            : group && <PublicDetail group={group} backLink={router.query.backLink}/>}
    </>);
};
export default Show;
async function getServerSideProps(context) {
    const queryClient = new QueryClient();
    const session = await unstable_getServerSession(context.req, context.res, authOptions);
    const token = context.params.token;
    try {
        const endpoint = session?.user ? getGroup(token, { Authorization: bearerHeader(session) }) : getGroup(token);
        await queryClient.fetchQuery(["groups", token], () => endpoint);
    }
    catch (error) {
        if (!session && error?.response?.status == 401) {
            return {
                redirect: {
                    destination: `${process.env.NEXT_PUBLIC_APP_URL}/sign_in?error=SessionRequired`,
                    permanent: false
                }
            };
        }
    }
    return {
        props: { dehydratedState: dehydrate(queryClient) }
    };
}

    async function __Next_Translate__getServerSideProps__195eb20497b__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/groups/[token]/index',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__195eb20497b__ as getServerSideProps }
  